/**
 * Spec 033/034: «Запросить ответ» in a discussion — the message becomes an addressed
 * request that waits in the addressee's «Решить». Pure, for the node tests.
 */
import type { AskDraft } from "@/api/chat";

export interface AskForm {
  addressee_id: string;
  action: string;
  personal: boolean;
  blocking: boolean;
  blocking_note: string;
}

export const EMPTY_ASK: AskForm = { addressee_id: "", action: "", personal: false, blocking: false, blocking_note: "" };
export const MAX_ACTION = 300;
export const MAX_BLOCKING_NOTE = 200;

/** The `ask` of the message, or why it cannot go yet. */
export function askOf(form: AskForm): { ask: AskDraft } | { error: string } {
  const action = form.action.trim();
  if (!form.addressee_id) return { error: "Выбери, кого спросить" };
  if (!action) return { error: "Напиши, что нужно от человека" };
  if (action.length > MAX_ACTION) return { error: `Что нужно — до ${MAX_ACTION} символов` };
  const note = form.blocking ? form.blocking_note.trim() : "";
  if (note.length > MAX_BLOCKING_NOTE) return { error: `Что стоит — до ${MAX_BLOCKING_NOTE} символов` };
  return {
    ask: {
      addressee_id: form.addressee_id,
      action,
      mode: form.personal ? "personal" : "agent_ok",
      blocking: form.blocking,
      ...(note ? { blocking_note: note } : {}),
    },
  };
}
